'use client';
import axios from 'axios';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import 'react-multi-carousel/lib/styles.css';
import AuthUser from '@/utils/AuthUser';
import SendPicture from '../../../../../components/SendPicture';
import classes from './AskSeller.module.css';
import { useAlertContext } from '@/context/alert';
import { useAuthContext } from '@/context';
import Image from 'next/image';

const AskSeller = (props) => {
	const { SET_ALERT } = useAlertContext();

	const { listing1, author } = props;
	const [listing, setListing] = useState();
	const [requestAuth, setRequestAuth] = useState(false);
	const [selectedImage, setSelectedImage] = useState();
	const [loading, setLoading] = useState(false);
	const [textLoading, setTextLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [fullImage, setFullImage] = useState(null);
	const [fullVideo, setFullVideo] = useState(null);
	const [message, setMessage] = useState(
		typeof window !== 'undefined'
			? localStorage?.getItem('listingComment') &&
			  localStorage?.getItem('listingComment') !== 'undefined' &&
			  localStorage?.getItem('listingComment') !== 'null'
				? localStorage?.getItem('listingComment')
				: ''
			: ''
	);

	const [showInputBox, setShowInputBox] = useState(false);

	const { auth } = useAuthContext();

	const [commentsLoading, setCommentsLoading] = useState(false);
	const getComments = async () => {
		setCommentsLoading(true);
		await axios
			.get(`${process.env.NEXT_PUBLIC_SERVER_API}/api/listings/${listing1._id}`)
			.then((res) => {
				setListing(res.data);
			})
			.catch((err) => {
				console.log(err);
			});
		setCommentsLoading(false);
	};

	useEffect(() => {
		getComments();
	}, [auth, listing1, author]);

	moment.updateLocale('en', {
		relativeTime: {
			future: 'in %s',
			past: '%s',
			s: 'seconds ago',
			ss: '%ss',
			m: 'minutes ago',
			mm: '%dm',
			h: 'an hour',
			hh: '%dh',
			d: 'a day',
			dd: '%dd',
			M: '%dM',
			MM: '%dM',
			y: 'a year',
			yy: '%dY',
		},
	});

	const requestAuthHandler = () => {
		setRequestAuth(true);
	};

	useEffect(() => {
		localStorage?.setItem('listingComment', message);
	}, [message]);

	const sendMessage = async (event) => {
		event.preventDefault();
		if (!message) {
			SET_ALERT({ msg: 'Type a message first', type: 'danger' });
			return;
		}

		if (!auth.isAuthenticated) {
			SET_ALERT({ msg: 'You need to be logged in first', type: 'danger' });

			return requestAuthHandler();
		}

		let newM = message;
		setTextLoading(true);
		await axios
			.post(
				`${process.env.NEXT_PUBLIC_SERVER_API}/api/listings/request-info/${listing._id}`,
				{
					message: newM,
				}
			)
			.then((res) => {
				setListing(res.data);
				SET_ALERT({ msg: 'Message sent!', type: 'success' });
				localStorage?.removeItem('listingComment');

				setMessage('');
			})
			.catch((err) => {
				SET_ALERT({ msg: 'Server error', type: 'danger' });
			});
		setTextLoading(false);
	};

	const deleteCommentHandler = async (id) => {
		await axios
			.get(
				`${process.env.NEXT_PUBLIC_SERVER_API}/api/admin/delete-request/${listing._id}/${id}`
			)
			.then((res) => {
				SET_ALERT({ msg: 'Comment deleted', type: 'success' });
				setListing(res.data);
			})
			.catch((err) => {
				SET_ALERT({ msg: 'Server error', type: 'danger' });
			});
	};

	const ref = useRef();

	useEffect(() => {
		const checkIfClickedOutside = (e) => {
			// If the menu is open and the clicked target is not within the menu,
			// then close the menu
			if (showInputBox && ref.current && !ref.current.contains(e.target)) {
				setShowInputBox();
			}
		};

		document.addEventListener('mousedown', checkIfClickedOutside);

		return () => {
			// Cleanup the event listener
			document.removeEventListener('mousedown', checkIfClickedOutside);
		};
	}, [showInputBox]);

	let commentData = new FormData();
	const sendImage = async () => {
		if (selectedImage) {
			const image = selectedImage;
			commentData.append('image', image);
			setLoading(true);
			await axios
				.post(
					`${process.env.NEXT_PUBLIC_SERVER_API}/api/listings/request-info/${listing._id}`,
					commentData
				)
				.then((res) => {
					setListing(res.data);
					SET_ALERT({ msg: 'Image uploaded!', type: 'success' });
				})
				.catch((error) => {
					SET_ALERT({
						msg: 'Server error',
						type: 'danger',
					});
				});
			setLoading(false);
		}
		setSelectedImage(null);
	};
	useEffect(() => {
		if (selectedImage) {
			sendImage();
		}
	}, [selectedImage]);

	const handleImageClick = (imageSrc, type) => {
		setFullImage();
		setFullVideo();
		if (type === 'video') {
			setFullVideo(imageSrc);
		} else {
			setFullImage(imageSrc);
		}

		setShowModal(true);
	};

	function linkify(text) {
		const urlPattern =
			/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
		return text.replace(
			urlPattern,
			'<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
		);
	}

	return (
		<>
			{requestAuth && (
				<AuthUser
					open={!auth.isAuthenticated}
					setRequestAuth={setRequestAuth}
				/>
			)}
			{showModal && (
				<div
					className={classes.modal}
					onClick={(e) => {
						if (e.target === e.currentTarget) {
							setShowModal(false);
						}
					}}
				>
					<div className={classes.modal_content}>
						<span
							className={classes.close_btn}
							onClick={() => setShowModal(false)}
						>
							x
						</span>
						{fullImage ? (
							<img src={fullImage} alt="Full-sized view" />
						) : fullVideo ? (
							<video src={fullVideo} controls />
						) : (
							''
						)}
					</div>
				</div>
			)}
			{author && listing && !auth.loading && (
				<div className={classes.container} id="askSellerTarget">
					<div className={classes.textContainer}>
						<div className={classes.profileImgContainer}>
							{(!auth.isAuthenticated && author.isBusiness) ||
							(auth.isAuthenticated &&
								author.isBusiness &&
								auth?.user?._id.toString() !== author._id.toString()) ? (
								<div className={classes.businessPic}>
									<Image
										src="https://ik.imagekit.io/kuj9zqlrx0or/Static/business_pic_white.png"
										width={50}
										height={50}
										loading="lazy"
										className={classes.businessIcon}
										alt={
											author?.firstName
												? `${author.firstName} Shop Used Furniture`
												: 'Shop Used Furniture Seller'
										}
									/>
								</div>
							) : (
								<Image
									width={50}
									height={50}
									className={classes.businessPic}
									src={`${author.picture}`}
									referrerPolicy="no-referrer"
									alt="author picture"
								/>
							)}
							<div className={classes.authorNameDescription}>
								{(!auth.isAuthenticated && author.isBusiness) ||
								(author.isBusiness &&
									auth.user._id.toString() !== author._id.toString()) ? (
									<div className={classes.name}>Professional Reseller</div>
								) : (
									<div className={classes.name}>{author.firstName}</div>
								)}
							</div>
						</div>
						<div className={classes.infoBanner}>
							Do not share any personal or contact information here
						</div>
					</div>

					<div className={classes.commentDiv}>
						{!commentsLoading &&
							listing.comments[0]?.sender &&
							listing.comments.map((comment, idx) => (
								<div key={idx}>
									{/* Left hand side (always display pics and names): comment.sender?._id !== author._id && !comment.sender?.admin
                      Right hand side: comment.sender?._id === author._id || comment.sender?.admin
                            Name of and image of sender displayed if:
                            - comment.sender?._id === auth?.user?._id
                            - or !comment.sender?.isBusiness
                            - or comment.sender?.admin
                    */}

									{comment.sender?._id !== author._id &&
									!comment.sender?.admin ? (
										<div className={classes.comment}>
											{/* Left hand side */}

											<div className={classes.col}>
												<Image
													src={
														comment.sender?.picture
															? comment.sender?.picture
															: 'https://ik.imagekit.io/kuj9zqlrx0or/Static/gray_cashew.png?tr=w-50,h-50'
													}
													width={50}
													height={50}
													alt={comment.sender?.firstName}
													className={
														comment.sender?.picture
															? classes.commentPicture
															: classes.commentPictureDefault
													}
												/>{' '}
												<h6 className={classes.userName}>
													{comment.sender?.firstName}
												</h6>
											</div>
											<div className={classes.box}>
												<div className={classes.commentText}>
													<h6
														className={
															comment.sender?._id === auth?.user?._id
																? classes.colorText
																: classes.text
														}
													>
														<div
															className={
																comment.sender?._id === auth?.user?._id
																	? classes.commentTriangleColor
																	: classes.commentTriangle
															}
														/>
														{comment.status === 'deleted' ? (
															<div className={classes.commentDeleted}>
																This comment has been deleted
															</div>
														) : comment.type === 'image' ? (
															<div>
																<img
																	src={comment.imageUrl}
																	alt="commentPhoto"
																	className={classes.sentImage}
																	onClick={() =>
																		handleImageClick(comment.imageUrl)
																	}
																/>
															</div>
														) : comment.type === 'video' ? (
															<div>
																<video
																	src={comment.imageUrl}
																	alt="Selected preview"
																	className={classes.sentImage}
																	onClick={() =>
																		handleImageClick(comment.imageUrl, 'video')
																	}
																/>
															</div>
														) : (
															<div
																dangerouslySetInnerHTML={{
																	__html: linkify(comment.text),
																}}
															/>
														)}
													</h6>

													{comment.date && (
														<div className={classes.commentDate}>
															{moment(comment.date).fromNow()}
														</div>
													)}
												</div>

												{auth.user?.admin && (
													<div className={classes.replyButtonContainer}>
														<div
															className={classes.deleteButton}
															onClick={() => deleteCommentHandler(comment._id)}
														>
															Delete
														</div>
													</div>
												)}
											</div>
										</div>
									) : (
										// Right hand side
										<div className={classes.reply}>
											<div className={classes.box}>
												<div className={classes.commentText}>
													{comment.date && (
														<div className={classes.commentDate}>
															{moment(comment.date).fromNow()}{' '}
														</div>
													)}
													<h6
														className={
															comment.sender?._id === auth.user?._id
																? classes.colorText1
																: classes.text1
														}
													>
														<div
															className={
																comment.sender?._id === auth.user?._id
																	? classes.replyTriangleColor
																	: classes.replyTriangle
															}
														/>
														{comment.status === 'deleted' ? (
															<div className={classes.commentDeleted}>
																This comment has been deleted
															</div>
														) : comment?.type === 'image' ? (
															<div>
																<img
																	src={comment.imageUrl}
																	alt="replyPhoto"
																	className={classes.sentImage}
																	onClick={() =>
																		handleImageClick(comment.imageUrl)
																	}
																/>
															</div>
														) : comment.type === 'video' ? (
															<div>
																<video
																	src={comment.imageUrl}
																	alt="Selected preview"
																	className={classes.sentImage}
																	onClick={() =>
																		handleImageClick(comment.imageUrl, 'video')
																	}
																/>
															</div>
														) : (
															<div
																dangerouslySetInnerHTML={{
																	__html: linkify(comment.text),
																}}
															/>
														)}
													</h6>
												</div>
												{auth?.user?.admin && (
													<div className={classes.replyButtonContainer}>
														<div
															className={classes.deleteButton}
															onClick={() => deleteCommentHandler(comment._id)}
														>
															Delete
														</div>
													</div>
												)}
											</div>
											<>
												{/* Right hand side */}
												{comment.sender?._id === auth?.user?._id ||
												!comment.sender?.isBusiness ||
												comment.sender?.admin ? (
													<>
														<div className={classes.col1}>
															<Image
																width={50}
																height={50}
																src={
																	comment.sender?.picture
																		? comment.sender?.picture
																		: 'https://ik.imagekit.io/kuj9zqlrx0or/Static/gray_cashew.png?tr=w-50,h-50'
																}
																alt={`${comment.sender?.firstName}`}
																className={
																	comment.sender?.picture
																		? classes.commentPicture
																		: classes.commentPictureDefault
																}
															/>{' '}
															<h6 className={classes.userName}>
																{comment.sender?.firstName}
																{comment.sender?._id === author._id ? (
																	<>
																		<br />
																		(Seller)
																	</>
																) : (
																	comment.sender?.admin && (
																		<>
																			{' '}
																			<br />
																			(admin)
																		</>
																	)
																)}
															</h6>
														</div>
													</>
												) : (
													<>
														<div className={classes.col1}>
															<div className={classes.businessPic}>
																<Image
																	width={50}
																	height={50}
																	src="https://ik.imagekit.io/kuj9zqlrx0or/Static/business_pic_white.png"
																	alt={
																		author?.firstName
																			? `${author.firstName} Shop Used Furniture`
																			: 'Shop Used Furniture Seller'
																	}
																	className={classes.businessIcon}
																/>{' '}
															</div>

															<h6 className={classes.userName}>Seller</h6>
														</div>
													</>
												)}
											</>
										</div>
									)}
								</div>
							))}{' '}
					</div>

					{!showInputBox && (
						<form onSubmit={sendMessage} className={classes.inputDiv}>
							{(listing?.author?._id === auth.user?._id ||
								listing?.author === auth.user?._id ||
								auth.user?.admin) &&
							loading
								? 'Uploading...'
								: (listing?.author?._id === auth.user?._id ||
										listing?.author === auth.user?._id ||
										auth.user?.admin) && (
										<SendPicture
											className={classes.sendPic}
											setSelectedImage={setSelectedImage}
											video={true}
										/>
								  )}
							<textarea
								type="text"
								value={message}
								rows={1}
								onChange={(e) => setMessage(e.target.value)}
								className={classes.input}
								placeholder="Type message here"
							/>

							<button
								disabled={textLoading || !message}
								type="submit"
								className={
									message ? classes.sendButton : classes.sendButtonDeactive
								}
							>
								{textLoading ? 'Sending...' : 'Send'}
							</button>
						</form>
					)}
				</div>
			)}
		</>
	);
};

export default AskSeller;
